import { ListItemMetaProps } from '@app/types'
import { List } from 'antd'

export const ListItemMeta: React.FC<ListItemMetaProps> = (props) => <List.Item.Meta {...props} />
